import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface StopPendingManagementIconProp extends Omit<SvgIconProps, `color`> {
  color?: string;
}

export const StopPendingManagementIcon = ({
  color = RoutalPalette.neutral10,
  style,
  ...props
}: StopPendingManagementIconProp) => {
  return (
    <SvgIcon {...props} viewBox="0 0 19 19" style={style}>
      <path
        d="M16.1383 4.5642C15.7603 3.7902 15.2203 3.1062 14.5363 2.5122C13.8433 1.9182 13.0333 1.4592 12.1333 1.1442C11.2243 0.820203 10.2703 0.658203 9.28929 0.658203C7.30929 0.658203 5.44629 1.3152 4.04229 2.5122C2.64729 3.7092 1.87329 5.2932 1.87329 6.9762C1.87329 9.4422 3.00729 12.0612 5.25729 14.7522C5.96829 15.5982 7.14729 16.8942 8.77629 18.2082L8.85729 18.2712C8.98329 18.3612 9.13629 18.4062 9.29829 18.4062C9.46029 18.4062 9.59529 18.3612 9.75729 18.2532C9.75729 18.2532 11.5663 16.9032 13.3483 14.7612C15.5533 12.1062 16.7143 9.4152 16.7143 6.9852C16.7143 6.1482 16.5253 5.3382 16.1473 4.5642H16.1383ZM11.2153 7.6692C10.5493 7.9752 10.0093 8.5152 9.70329 9.1722L9.29829 10.0452L8.89329 9.1722C8.58729 8.5152 8.04729 7.9752 7.38129 7.6692L6.49929 7.2642L7.38129 6.8592C8.04729 6.5532 8.58729 6.0132 8.89329 5.3562L9.29829 4.4832L9.70329 5.3562C10.0093 6.0132 10.5493 6.5532 11.2153 6.8592L12.0973 7.2642L11.2153 7.6692Z"
        fill={color}
      />
    </SvgIcon>
  );
};
